import React from 'react';
import Icon from '../../../components/AppIcon';

const InspectorPerformancePanel = ({ inspectors }) => {
  return (
    <div className="p-4 md:p-6 rounded-xl border border-border bg-card mb-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-base md:text-lg font-semibold text-foreground">Inspector Performance</h3>
          <p className="caption text-muted-foreground mt-1">Current shift analytics</p>
        </div>
      </div>
      <div className="space-y-4">
        {inspectors?.map((inspector, index) => (
          <div key={index} className="p-4 rounded-xl bg-muted/30">
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 text-primary font-semibold text-sm">
                  {inspector?.name?.split(' ')?.map(n => n?.[0])?.join('')}
                </div>
                <div>
                  <h4 className="text-sm font-medium text-foreground">{inspector?.name}</h4>
                  <p className="caption text-muted-foreground">{inspector?.role}</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-sm font-semibold text-foreground data-text">
                  {inspector?.completedToday}
                </p>
                <p className="caption text-muted-foreground">Completed</p>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-3">
              <div className="text-center">
                <div className="flex items-center justify-center gap-1 mb-1">
                  <Icon name="CheckCircle2" size={14} color="var(--color-success)" />
                  <span className="text-sm font-medium text-foreground data-text">
                    {inspector?.approvalRate}%
                  </span>
                </div>
                <p className="caption text-muted-foreground">Approval</p>
              </div>
              <div className="text-center">
                <div className="flex items-center justify-center gap-1 mb-1">
                  <Icon name="Clock" size={14} color="var(--color-primary)" />
                  <span className="text-sm font-medium text-foreground data-text">
                    {inspector?.avgTime}m
                  </span>
                </div>
                <p className="caption text-muted-foreground">Avg Time</p>
              </div>
              <div className="text-center">
                <div className="flex items-center justify-center gap-1 mb-1">
                  <Icon name="Target" size={14} color="var(--color-accent)" />
                  <span className="text-sm font-medium text-foreground data-text">
                    {inspector?.accuracy}%
                  </span>
                </div>
                <p className="caption text-muted-foreground">Accuracy</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InspectorPerformancePanel;